module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading_with_sub/heading_with_sub_3-534fc7bdb453e3bc45e3061529d03410.png";